export default __webpack_public_path__ + "static/media/btg.952d6804.png";